import {
    FETCH_COMPLETE_WHEEL_FAILURE,
    FETCH_COMPLETE_WHEEL_OPTIONS_FAILURE,
    FETCH_COMPLETE_WHEEL_OPTIONS_REQUEST,
    FETCH_COMPLETE_WHEEL_OPTIONS_SUCCESS,
    FETCH_COMPLETE_WHEEL_REQUEST,
    FETCH_COMPLETE_WHEEL_SUCCESS,
    FETCH_COMPLETE_WHEELS_FAILURE,
    FETCH_COMPLETE_WHEELS_REQUEST,
    FETCH_COMPLETE_WHEELS_SUCCESS,
    UPDATE_COMPLETE_WHEELS_FILTER_VALUES,
} from '../../actionTypes';
import {
    completeWheelOptionsResponseSelector,
    completeWheelResponseSelector,
    completeWheelsOptionsSearchParamsSelector,
    completeWheelsResponseSelector,
    completeWheelsSearchParamsSelector,
} from '../../selectors/standort/completeWheels';
import { standortUrlSelector } from '../../selectors/url';
import { shouldFetch } from '../../fetchStatus';
import { apiClient } from '../../../helpers/apiHelperV2';

export const fetchCompleteWheelsIfNeeded = ({ selectedOptions }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        const searchParams = completeWheelsSearchParamsSelector(state, { selectedOptions });
        const completeWheelsResponse = completeWheelsResponseSelector(state, { selectedOptions });

        if (shouldFetch(completeWheelsResponse.status)) {
            dispatch({
                type: FETCH_COMPLETE_WHEELS_REQUEST,
                payload: { standortUrl, searchParams },
            });

            try {
                const res = await apiClient.get(`/api/v1/standorte/${standortUrl}/completeWheels?${searchParams}`);

                dispatch({
                    type: FETCH_COMPLETE_WHEELS_SUCCESS,
                    payload: { standortUrl, searchParams, data: res.data },
                });
            } catch (error) {
                dispatch({
                    type: FETCH_COMPLETE_WHEELS_FAILURE,
                    payload: { standortUrl, searchParams, error },
                });
            }
        }
    };
};

export const fetchCompleteWheelIfNeeded = ({ completeWheelId }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);
        const completeWheelResponse = completeWheelResponseSelector(state, { completeWheelId });

        if (shouldFetch(completeWheelResponse.status)) {
            dispatch({
                type: FETCH_COMPLETE_WHEEL_REQUEST,
                payload: { standortUrl, completeWheelId },
            });

            try {
                const {
                    data: { completeWheel },
                } = await apiClient.get(`/api/v1/standorte/${standortUrl}/completeWheels/${completeWheelId}`);

                dispatch({
                    type: FETCH_COMPLETE_WHEEL_SUCCESS,
                    payload: { standortUrl, completeWheelId, completeWheel },
                });
            } catch (error) {
                dispatch({
                    type: FETCH_COMPLETE_WHEEL_FAILURE,
                    payload: { standortUrl, completeWheelId, error },
                });
            }
        }
    };
};

export const fetchCompleteWheelOptionsIfNeeded = ({ selectedOptions }) => {
    return async function (dispatch, getState) {
        const state = getState();
        const standortUrl = standortUrlSelector(state);

        const searchParams = completeWheelsOptionsSearchParamsSelector(state, {
            selectedOptions,
        });
        const completeWheelOptionsResponse = completeWheelOptionsResponseSelector(state, {
            selectedOptions,
        });
        if (shouldFetch(completeWheelOptionsResponse.status)) {
            dispatch({
                type: FETCH_COMPLETE_WHEEL_OPTIONS_REQUEST,
                payload: { standortUrl, searchParams },
            });

            try {
                const res = await apiClient.get(
                    `/api/v1/standorte/${standortUrl}/completeWheels/options${searchParams ? `?${searchParams}` : ''}`
                );

                dispatch({
                    type: FETCH_COMPLETE_WHEEL_OPTIONS_SUCCESS,
                    payload: { standortUrl, searchParams, data: res.data },
                });
            } catch (error) {
                dispatch({
                    type: FETCH_COMPLETE_WHEEL_OPTIONS_FAILURE,
                    payload: { standortUrl, searchParams, error },
                });
            }
        }
    };
};

export const updateCompleteWheelsSelectedOptions = ({ standortUrl, selectedOptionsUpdate }) => ({
    type: UPDATE_COMPLETE_WHEELS_FILTER_VALUES,
    payload: { standortUrl, selectedOptionsUpdate },
});
